/* eslint-disable no-unused-vars, react-hooks/exhaustive-deps */
import React, { Fragment, useState, useEffect } from "react";
import customFunction from "../../../../customFunction/customFunction";
import Pagination from "../../../Pagination/Pagination";

const VacuumModelResult = (props) => {
  const pageSize = props.pageSize;
  const [indexOfLast, setIndexOfLast] = useState([1 * pageSize]);
  const [indexOfFirst, setIndexOfFirst] = useState([1 * pageSize - pageSize]);

  useEffect(() => {
    setIndexOfLast(1 * pageSize);
    setIndexOfFirst(1 * pageSize - pageSize);
  }, []);

  function handleChildClick(currentPage) {
    setIndexOfLast(currentPage * pageSize);
    setIndexOfFirst(currentPage * pageSize - pageSize);
    customFunction.goTo("#searchResult");
  }
  let dataBind = props.data.slice(indexOfFirst, indexOfLast);
  return (
    <React.Fragment>
      {dataBind.length &&
        dataBind.map((model) => (
          <div
            className="row new-data"
            key={model.vacuumModelName + " " + model.vacuumSeriesName}
          >
            <div className="col-sm-12 col-md-12">
              <div className="card cardNew">
                <div className="card-body">
                  <div className="row ">
                    <div className="col-md-12">
                      <h5>
                        {model.vacuumModelName +
                          " " +
                          (model.vacuumSeriesName == null
                            ? ""
                            : model.vacuumSeriesName)}
                      </h5>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}

      <Pagination
        totalRecords={props.data.length}
        pageSize={pageSize}
        onChildClick={handleChildClick}
      />
    </React.Fragment>
  );
  // }
};
export default VacuumModelResult;
